
import { createReducer, createNamespacer } from '../commons/js/utils/reducer';
import { fromPairs as _fromPairs } from 'lodash';


const namespacers = {
    forgotPassword: createNamespacer("FORGOT_PASSWORD"),
}

const initialstate = {
    email: {
        value: '',
        error: '',
        showError: '',
    },
    error: '',
    showForgotPassword: false,

}

const forgotPasswordReducer = createReducer(initialstate, {
    [namespacers.forgotPassword("SET_EMAIL")]:  (state, action) => {
        return {
            ...state,
            email: {
                ...state.email,
                value: action.payload.value
            },
        }

    },

    "SHOW_FORGOT_PASSWORD": (state, action) => {
        return {
            ...state,
            showForgotPassword: action.payload.value,
        }
    },

    [namespacers.forgotPassword("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [namespacers.forgotPassword("CLEAR_FORM")]: (state, action) => {
        return {
            ...state
            , email : {
                ...initialstate.email,
            }
        }
    },
    [namespacers.forgotPassword("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },
})

export default forgotPasswordReducer;